module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "my-header",
    class: {
      fixed: _vm.$store.getters['navigator/isHeaderFixed']
    },
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.currentUser) ? _c('v-flex', {
    attrs: {
      "mx-5": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "header"
  }, [_c('router-link', {
    attrs: {
      "to": "/album"
    }
  }, [_c('v-toolbar-title')], 1), _vm._v(" "), (['video'].indexOf(_vm.currentPage) > -1) ? _c('v-btn', {
    staticClass: "btn-live",
    attrs: {
      "to": "/video#follows"
    }
  }, [_vm._v("Live")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'album'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('album')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    staticStyle: {
      "margin-top": "3px"
    },
    attrs: {
      "src": "/static/images/ic_music_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "3px"
    },
    attrs: {
      "src": "/static/images/ic_music.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Album")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'product'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('product')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    staticStyle: {
      "margin-top": "-2px"
    },
    attrs: {
      "src": "/static/images/ic_tag_active.svg",
      "width": "18"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "-2px"
    },
    attrs: {
      "src": "/static/images/ic_tag.svg",
      "width": "18"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Shop")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: ['video'].indexOf(_vm.currentPage) > -1
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('video')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_video_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_video.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Video")])], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.stream > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.stream))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'feed'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('feed')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_home_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_home.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Feed")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.activity > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.activity))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'activity'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('activity')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_alarm_active.svg",
      "width": "18"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_alarm.svg",
      "width": "18"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Activity")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.message > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.message))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'messages'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('messages')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_message_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_message.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Messages")])], 1)], 1), _vm._v(" "), _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.cart > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.cart))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'cart'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('cart')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    attrs: {
      "src": "/static/images/ic_cart_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/ic_cart.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Cart")])], 1)], 1), _vm._v(" "), (
    _vm.currentUser && ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('v-badge', {
    attrs: {
      "color": "red"
    }
  }, [(_vm.$store.state.activity.badge.sell > 0) ? _c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.$store.state.activity.badge.sell))]) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    class: {
      active: _vm.currentPage === 'sell'
    },
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('sell')
      }
    },
    slot: "activator"
  }, [_c('img', {
    staticClass: "active",
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "src": "/static/images/ic_delivery_active.svg",
      "width": "20"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "src": "/static/images/ic_delivery.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Sell")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser) ? _c('v-menu', {
    staticClass: "profile-menu",
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "nudge-top": -5,
      "nudge-left": 0,
      "content-class": "profile-menu__content"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [(_vm.currentUser) ? _c('div', {
    staticClass: "profile-image",
    style: ({
      'background-image': 'url(' + _vm.currentUser.avatar.thumb.url + ')',
    })
  }) : _vm._e()]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "profile",
    attrs: {
      "avatar": "",
      "to": '/' + _vm.currentUser.slug
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": _vm.currentUser.avatar.url
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                " + _vm._s(_vm.currentUser.username) + "\n                "), (
    ['artist', 'label', 'brand'].indexOf(
      _vm.currentUser.user_type
    ) > -1
  ) ? _c('v-icon', {
    staticClass: "user-status online"
  }, [_vm._v("fa-check-circle")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("View Profile")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (
    !_vm.$store.getters['app/disabledLiveVideo'] &&
    _vm.currentUser.enabled_live_video && ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('v-list-tile', {
    attrs: {
      "to": ("/user/" + (_vm.currentUser.slug) + "/video")
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Live Video")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Broadcast a live stream")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.user_type == 'artist' || _vm.currentUser.user_type == 'brand') ? _c('v-list-tile', {
    attrs: {
      "to": "/upload/album"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Upload")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Upload an album")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentUser.user_type == 'artist') ? _c('v-list-tile', {
    key: "manage",
    attrs: {
      "to": "/albums"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Manage")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Edit your albums")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    key: "settings",
    attrs: {
      "to": "/settings"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Settings")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Edit profile, password, bank info")])], 1)], 1), _vm._v(" "), (
    ['listener', 'artist', 'label'].indexOf(_vm.currentUser.user_type) >
    -1
  ) ? _c('v-list-tile', {
    key: "payments",
    attrs: {
      "to": "/payments"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Payments")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("View transactions, refunds")])], 1)], 1) : _vm._e(), _vm._v(" "), (['admin', 'moderator'].indexOf(_vm.currentUser.user_type) > -1) ? _c('v-list-tile', {
    key: "admin",
    attrs: {
      "to": "/admin"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Admin")])], 1)], 1) : _vm._e(), _vm._v(" "), (
    ['artist', 'brand', 'label'].indexOf(_vm.currentUser.user_type) > -1
  ) ? _c('v-list-tile', {
    key: "invite",
    on: {
      "click": function($event) {
        _vm.openInviteDialog()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Invite artist/brand")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Invite your team")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    key: "support",
    on: {
      "click": _vm.goSupport
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Support")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("Help docs")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    key: "signout",
    on: {
      "click": _vm.signOut
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Sign Out")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "width": "20px",
      "height": "20px",
      "viewBox": "0 0 28 28",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("Group 22")]), _vm._v(" "), _c('desc', [_vm._v("Created with Sketch.")]), _vm._v(" "), _c('defs'), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Design",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "searchIcon",
      "transform": "translate(-732.000000, -61.000000)",
      "stroke": "#FFFFFF",
      "stroke-width": "1.5999999"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-29",
      "transform": "translate(710.000000, 50.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-22",
      "transform": "translate(23.000000, 12.000000)"
    }
  }, [_c('circle', {
    attrs: {
      "id": "Oval-2",
      "cx": "11.375",
      "cy": "11.375",
      "r": "11.375"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.5,19.5 L25.59375,25.59375",
      "id": "Line",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])])])])])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    staticClass: "search-field",
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "Search artist, song or keyword"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.goToSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })])])], 1) : _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "header"
  }, [_c('router-link', {
    attrs: {
      "to": "/album"
    }
  }, [_c('v-toolbar-title')], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('login')
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "dark": "",
      "round": "",
      "color": "green"
    },
    nativeOn: {
      "click": function($event) {
        _vm.choosePage('register')
      }
    }
  }, [_vm._v("Sign Up")])], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "content-class": "invite-dialog",
      "width": "440"
    },
    model: {
      value: (_vm.show_invite_dialog),
      callback: function($$v) {
        _vm.show_invite_dialog = $$v
      },
      expression: "show_invite_dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Invite Artist/Brand")]), _vm._v(" "), _c('v-card-text', [_vm._v("Link expires in 72 hours and can only be used once")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "dark": "",
      "block": "",
      "color": "black"
    },
    nativeOn: {
      "click": function($event) {
        _vm.createInvitation()
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("fa-link")]), _vm._v(" Copy Link")], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.link_copied),
      expression: "link_copied"
    }],
    staticClass: "link-copied"
  }, [_vm._v("link has been copied")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-df161328","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 1855
// module chunks = 180